module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }